export const getMinStayForDate = ({
  minimumStays = [],
  selectedRatePlanId,
}) => {
  const minStayObj =
    typeof minimumStays === "object"
      ? minimumStays.find((item) => item.ratePlanId === selectedRatePlanId)
      : null;
  const minStayForDate = minStayObj ? minStayObj.minStay : 0;

  return minStayForDate;
};
